import { Dropdown as UiDropdown } from "@anna-money/anna-web-ui";
import classNames from "classnames";
import type { ComponentProps, FC } from "react";
import type { DropdownOption } from "../../sections/obPaymentPage/helpers";
import { Label } from "../label/label";
import styles from "./Dropdown.module.scss";

type ValueType = DropdownOption["value"];

type FieldGroupOrder = ComponentProps<typeof UiDropdown>["fieldGroupPosition"];

type DropdownProps = {
  name: string;
  value: Nullable<ValueType>;
  options: DropdownOption[];
  label?: string;
  className?: string;
  hasError?: boolean;
  fieldGroupPosition?: FieldGroupOrder;
  onChange?: (value: ValueType) => void;
};

export const Dropdown: FC<DropdownProps> = ({
  name,
  options,
  value,
  onChange,
  label,
  hasError,
  fieldGroupPosition,
  className,
}: DropdownProps) => (
  <div className={classNames(styles.wrapper, className)}>
    {label && <Label labelText={label} />}
    <UiDropdown
      className={styles.dropdown}
      name={name}
      size="l"
      value={value ?? undefined}
      options={options}
      placeholder="--"
      hasError={hasError}
      fieldGroupPosition={fieldGroupPosition}
      onChange={onChange}
    />
  </div>
);
